import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '../../../tools/makeStyles';

const MAX_WIDTH = 840;

const useStyles = makeStyles((theme) => ({
  previewContainer: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    width: '100%',
    overflow: 'hidden',
    justifyContent: 'center',
  },
  root: {
    width: '100%',
    maxWidth: MAX_WIDTH,
    paddingLeft: 70,
    paddingRight: 70,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    margin: '0px auto',
  },
  spacer: {
    marginTop: 48,
    marginBottom: 48,
  },
  blockStructure: {
    display: 'block',
    [theme.breakpoints.down('md')]: {
      padding: '0px 24px',
    },
  },
  gridWidth: {
    width: '100%',
  },
  previewTitle: {
    color: theme.palette.mainaccent || theme.legacyPalette.mainaccent,
    fontSize: theme.spacing(3),
    fontWeight: 'bold',
    height: '50%',
    paddingBottom: 8,
  },
  required: {
    color: 'red',
  },
  desc: {
    padding: theme.spacing(1, 0),
  },
  previewDescription: {
    fontSize: theme.spacing(2),
    color: theme.palette.common.black,
    fontWeight: 'normal',
  },
}));

function Container({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.previewContainer}>
      <div className={classes.root}>
        <div className={classes.spacer}>
          <div className={classes.blockStructure}>{children}</div>
        </div>
      </div>
    </div>
  );
}

Container.propTypes = {
  children: PropTypes.node,
  isRequired: PropTypes.bool,
  showDescription: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Container;
